const Validators = {};

Validators.validateLatitude = latitude => {
  const REGEX = /^-?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
  return REGEX.test(latitude);
};

Validators.validateLongitude = longitude => {
  const REGEX = /^-?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/;
  return REGEX.test(longitude);
};

Validators.validateEmail = email => {
  const REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return REGEX.test(email);
};

Validators.validateEmailInDomainList = (email, domainList) => {
  if (!domainList || domainList.trim() == '*') return true;

  let domainArray = domainList.split(',').map(d => d.trim().toLowerCase());
  let emailDomain = (email.includes('@') ? email.split('@')[1] : email).trim().toLowerCase();

  return domainArray.includes(emailDomain);
};

Validators.validateOldPassword = password => {
  const REGEX = /^.{8,50}$/;
  return REGEX.test(password);
};

Validators.validateNewPassword = password => {
  const REGEX = /^(?=.*\d.*\d)(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*[!&*@#$%].*[!&*@#$%]).{8,50}$/;
  return REGEX.test(password);
};

Validators.validateIntegerNumberBetweenRange = (value, lowerLimit, upperLimit) => {
  if (
    value.indexOf('e') !== -1 ||
    value.indexOf('.') !== -1 ||
    value % 1 !== 0 ||
    value > upperLimit ||
    value < lowerLimit
  ) {
    return false;
  }
  return true;
};

Validators.validateStringBetweenRange = (s, lowerLimit = 0, upperLimit = 200) => {
  return typeof s === 'string' && lowerLimit <= s.length && s.length <= upperLimit && s.match(/^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/i);
};

export default Validators;
